import Vue from "vue";
import VueI18n from "vue-i18n";
import VueCookie from "vue-cookie";

Vue.use(VueI18n);

const messages = {
  en: {
    en: "English",
    ru: "Russian",
    zh: "Chinese",

    extra: "Extra",
    extra_llc: "Extra LLC",
    post: "Post",
    extrapost: "ExtraPost",
    home: "Home",
    description: "ExtraPost — multi-carrier shipping platform.",
    keywords:
      "shipping, API, logistics, platform, cloud, carrier, postal, ecommerce",
    main_title: "E-commerce logistics platform",

    learn_more: "Learn More",
    contact_us: "Contact Us",
    checkout: "Checkout",
    checkout_description:
      "ExtraPost will help you build straightforward checkout experiense with shipping widgets",
    order_checkout: "Order Checkout",
    shipping: "Shipping",
    products_shipping: "Products Shipping",
    tracking: "Tracking",
    parcel_tracking: "Parcel Tracking",
    fulfillment: "Fulfillment",
    reports: "Reports",
    enrichment: "Profit",
    parcel: "Parcel",
    parcels: "Parcels",
    parcels_control_center: "Parcels Control Center",

    solutions: "Solutions",
    contacts: "Contacts",

    demo_request: "Request a Demo",
    submit_application: "Request a Demo",
    demo_request_explanation:
      "We will contact you, answer your questions and present key platform features",
    name: "Name",
    phone: "Phone",
    email: "Email",
    comment: "Comment",
    company: "Company",
    submit: "Submit",
    i_agree:
      "I agree to be contacted by ExtraPost about product demonstration.",
    name_is_required: "Name is required",
    name_at_least_2_characters: "Name must have at least 2 characters",
    email_is_required: "Email is required",
    email_invalid: "Email is invalid",
    phone_is_required: "Phone is required",
    phone_at_least_10: "Phone must contain at least 10 characters",
    phone_only_digits_and_symbols:
      "Phone must contain only digits, braces, hyphens and spaces",
    checkbox_is_required: "You must agree to the terms",
    form_sent_success: "Form sent successfully. Wait for a call",

    page_not_found: "Page not found",

    h: "h",
    hour: "hour",
  },
  ru: {
    en: "Английский",
    ru: "Русский",
    zh: "Китайский",

    extra: "Экстра",
    extra_llc: "ООО «Экстра»",
    post: "Почта",
    extrapost: "ЭкстраПочта",
    home: "Главная",
    description:
      "Интеграция со СДЭК, Почтой, ДПД, ПикПойнт, Боксберри и др. Сравнение тарифов, API, карта ПВЗ, сборка и отслеживание посылок, обработка платежей и возвратов, проверка адресов.",
    keywords:
      "ЭкстраПочта, отправка, логистика, интернет-торговля, оформление заказ, отслеживание, автоматизация, платформа, интеграция, перевозчик",
    main_title: "Логистическая платформа для интернет-торговли",

    checkout: "Оформление",
    order_checkout: "Оформление заказа",
    how_it_works: "Как это работает",
    tariffs: "Тарифы",
    advantages: "Что это даст?",
    checkout_description:
      "ЭкстраПочта увеличит конверсию корзины с помощью виджета доставки, на лету рассчитает стоимость и сроки.",
    widget: "Виджет",
    shipping: "Отправка",
    parcels_control_center: "Центр Управления Посылками",
    parcels: "Посылки",
    parcel: "Посылка",
    products_shipping: "Отправка товаров",
    tracking: "Отслеживание",
    fulfillment: "Фулфиллмент",
    parcel_tracking: "Отслеживание посылок",
    reports: "Отчёты",
    enrichment: "Обогащение",

    solutions: "Решения",
    contacts: "Контакты",

    learn_more: "Узнать больше",
    contact_us: "Связаться с нами",
    view_widget: "Посмотреть виджет",
    delivery_widget: "Виджет доставки",
    delivery_widget_fitting: "Примерка виджета доставки",
    widget_fitting_explanation:
      "Введите адрес страницы любого товара на вашем сайте и CSS-селектор области, куда хотите примерить виджет, и мы покажем вам, как это будет работать именно у вас!",
    product_page: "Адрес страницы товара",
    css_selector: "Селектор CSS области, куда встроить виджет",
    try_on: "Примерить",
    demo_request: "Оставить заявку",
    submit_application: "Оставить заявку",
    demo_request_explanation:
      "Мы свяжемся с вами, ответим на вопросы и покажем возможности платформы для вашего бизнеса.",

    name: "Имя",
    phone: "Телефон",
    email: "Эл. почта",
    comment: "Комментарий",
    company: "Компания",
    submit: "Отправить",
    i_agree: "Соглашаюсь на обработку данных в ЭкстраПочте.",
    name_is_required: "Имя обязательно",
    name_at_least_2_characters: "Имя минимум из двух букв",
    email_is_required: "Эл. почта обязательна",
    email_invalid: "Неверный формат эл. почты",
    phone_is_required: "Телефон обязателен",
    phone_at_least_10: "Телефон должен быть не короче 10 символов",
    phone_only_digits_and_symbols:
      "Телефон может содержать только цифры, скобки, дефисы и пробелы. Можно плюс.",
    checkbox_is_required: "Нужно согласиться с обработкой данных.",
    form_sent_success: "Заявка отправлена, ожидайте звонка.",

    page_not_found: "Страница не найдена",

    h: "ч",
    hour: "час",
  },
  zh: {
    en: "英语",
    ru: "俄语",
    zh: "中文语",

    extra: "额外",
    post: "邮局",

    extrapost: "额外邮局",
    description: "额外邮局",
    main_title: "电子商务物流平台",
    home: "首页",

    learn_more: "学到更多",

    solutions: "解决方案",
    checkout: "结帐",
    shipping: "运输",
    tracking: "追踪",
    reports: "报告",
    enrichment: "利润",
    contacts: "联络人",

    parcel: "包",
    parcels: "包裹",

    demo_request: "要求演示",
    submit: "提交",

    h: "时",
    hour: "小时",
  },
};

function detectLocale() {
  var locale = VueCookie.get("currentLang");
  if (locale !== null) {
    return locale;
  } else {
    locale = navigator && navigator.language.substr(0, 2);
    if (["ru", "en", "zh"].includes(locale)) {
      return locale;
    } else if (
      [
        "uk",
        "be",
        "az",
        "kk",
        "hy",
        "lv",
        "lt",
        "mo",
        "ka",
        "uz",
        "sr",
      ].includes(locale)
    ) {
      return "ru";
    } else if (["ko", "ja", "mn"].includes(locale)) {
      return "zh";
    } else if (["de", "it", "fr", "es"].includes(locale)) {
      return "en";
    } else {
      return "ru";
    }
  }
}

const i18n = new VueI18n({
  locale: detectLocale(), // set locale from browser settings
  fallbackLocale: "en", // set fallback locale
  silentFallbackWarn: true,
  messages, // set locale messages
});

export default i18n;
export { detectLocale };
